import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AdminListMain } from "../../../../SharedComponents/ListView";

export default function RowInfo({ test }) {
  const { t } = useTranslation();

  return (
    <AdminListMain>
      <span className="admin-list-id">{test.id}</span>
      <span className="admin-list-title">{test.name}</span>
      <span className="admin-list-meta">
        {test.scopes?.length} {t("scope")}
      </span>
      <span className="admin-list-meta">
        {test.duration / 60} {t("minute")}
      </span>
      {test.assessments?.map((assessment, m) => (
        <Badge key={"te" + m} bg={assessment.isB2b ? "success" : "secondary"}>
          {assessment.name}
        </Badge>
      ))}
    </AdminListMain>
  );
}
